import { BasePagesEnum, BaseSubPageKey } from '@omnia/ui/src/lib'

export class PagesEnum extends BasePagesEnum {
    public Home = 'Home'
    public Generic = 'Generic'
    public Films = 'Films'
    public Events = 'Events'
    public FilmDetails = 'FilmDetails'
    public EventDetails = 'EventDetails'
    public Cinemas = 'Cinemas'
    public Cinema = 'Cinema'
    public SignIn = 'SignIn'
    public SignUp = 'SignUp'
    public Member = 'Member'
    public PasswordReset = 'PasswordReset'
}

export class MemberSubPages extends BaseSubPageKey<PagesEnum> {
    public parent: 'Member'
    public MemberOverview = 'MemberOverview'
    public MemberUpdateDetails = 'MemberUpdateDetails'
    public MemberRechargePoints = 'MemberRechargePoints'
    public MemberBookingsAndTransactions = 'MemberBookingsAndTransactions'
    public MemberRewardsAndOffers = 'MemberRewardsAndOffers'
    public MemberWatchlist = 'MemberWatchlist'
}
